import "core-js/es6/array"
import "core-js/fn/symbol/iterator.js"; // react-app-polyfill/ie11 is missing this polyfill
import "react-app-polyfill/ie11";
import "./index.css";

if ("Map" in window && "Set" in window) {
  require("./main");
} else {
  fetch("old_browser_partial.html")
    .then(r => r.text())
    .then(template => (document.getElementById("root").innerHTML = template))
    .catch(
      () =>
        (document.getElementById("root").innerHTML = "Error. Try again later.")
    );
}
